import { render } from "./CompleteLayout.vue?vue&type=template&id=2c6b69b2"
import script from "./CompleteLayout.vue?vue&type=script&lang=js"
export * from "./CompleteLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__